<template>
  <component
    :is="iconPath"
    v-tooltip.bottom="tooltip"
    viewBox="0 0 24 24"
    aria-hidden="true"
    :stroke-width="strokeWidth"
  />
</template>

<script setup>
import { defineAsyncComponent, shallowRef, toRefs, watch } from 'vue'
import { useProp } from '@/composables/useProp.js'

const props = defineProps({
  strokeWidth: useProp(Number, 1),
  fill: useProp(Boolean, false),
  tooltip: useProp(String),
  name: useProp(String, '', true)
})

const iconPath = shallowRef()
const { name } = toRefs(props)

watch(name, async (icon) => {
  if (!icon) return
  iconPath.value = defineAsyncComponent(() =>
    import(`../../assets/icons/${icon.replace('tabler-', '')}.svg`)
  )
}, { immediate: true })

</script>
